module.exports = __webpack_public_path__ + "static/beauty1-7ce176702272e13dbf7b6b175ea21531.jpg";